import React from "react";
import { createHashRouter } from "react-router-dom";
import ReadingPage from "./components/ReadingPage";

const router = createHashRouter([
  { path: "/", element: <ReadingPage /> },
]);

export default router;
